import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    //INICIO DIPLOMADOS
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/abordaje-de-las-violencias-y-la-perspectiva-de-género",
      name: "abordaje",
      component: () => import("@/views/diplomados/Abordajede")
    },
    {
      path: "/transtorno-deficit",
      name: "transtornodeficit",
      component: () => import("@/views/diplomados/TranstornoDeficit")
    },
    {
      path: "/multidisciplinario-en-derechos-humanos",
      name: "multiHumanos",
      component: () => import("@/views/diplomados/MultiDerHumanos")
    },
    {
      path: "/hipnosis",
      name: "Hipnosis",
      component: () => import("@/views/diplomados/Hipnosis")
    },
    {
      path: "/juicios-orales",
      name: "Juicios",
      component: () => import("@/views/diplomados/Juicios")
    },
    {
      path: "/pruebas-psicologicas",
      name: "PruebasPsico",
      component: () => import("@/views/diplomados/Pruebaspsico")
    },
    {
      path: "/psicopatología",
      name: "Psicopatologia",
      component: () => import("@/views/diplomados/Psicopatologia")
    },
    {
      path: "/psicoterapia-para-niños-con-discapacidad",
      name: "Psicoterapia",
      component: () => import("@/views/diplomados/Psicoterapia")
    },
    {
      path: "/psicoterapia-transpersonal-integrativa",
      name: "Ptransin",
      component: () => import("@/views/diplomados/Ptransin")
    },
    {
      path: "/tanatologia-transpersonal",
      name: "Tanatologiatrans",
      component: () => import("@/views/diplomados/Tanatologiatrans")
    },
    {
      path: "/terapia-de-lenguaje",
      name: "Teralengua",
      component: () => import("@/views/diplomados/Teralengua")
    },
    {
      path: "/terapia-de-juego",
      name: "Terajuegos",
      component: () => import("@/views/diplomados/Terajuegos")
    },
    {
      path: "/terapia-de-pareja-y-sexualidad",
      name: "Terapareja",
      component: () => import("@/views/diplomados/Terapareja")
    },
    {
      path: "/bases-clinicas-de-la-gerontología",
      name: "BasesClinicas",
      component: () => import("@/views/diplomados/BasesClinicas")
    },
    {
      path: "/interdisciplinario-en-Derechos-Humanos",
      name: "Interdisciplinario",
      component: () => import("@/views/diplomados/Interdisciplinario")
    },
    {
      path: "/trastorno-del-espectro-autista-TEA",
      name: "trastorno",
      component: () => import("@/views/diplomados/EspectroAutista")
    },
    {
      path: "/diagnóstico-clínico-a-través-del-cine",
      name: "diagnosticoc",
      component: () => import("@/views/diplomados/DiagCine")
    },
    {
      path: "/introducción-a-diversos-pensamientos-filosóficos",
      name: "pensamientofiloso",
      component: () => import("@/views/diplomados/PensamientoFiloso")
    },
    {
      path: "/dificultades-y-trastornos-en-el-aprendizaje",
      name: "transaprendizaje",
      component: () => import("@/views/diplomados/DificultadesAprendizaje")
    },
    {
      path: "/habilidades-clínicas",
      name: "habilidadesclinicas",
      component: () => import("@/views/diplomados/HabilidadesClinicas")
    },
    {
      path: "/administración-base-de-la-gestión-escolar",
      name: "gestionescolar",
      component: () => import("@/views/diplomados/GestionEscolar")
    },
    {
      path: "/Intervención-e-identificación-en-el-TDAH",
      name: "Tdah",
      component: () => import("@/views/diplomados/Tdah")
    },
    {
      path: "/psicomotrocidad-infantil",
      name: "Infantil",
      component: () => import("@/views/diplomados/Pisicomotrocidadinf")
    },
    {
      path: "/terapia-juego-ii",
      name: "terapiajuegoii",
      component: () => import("@/views/diplomados/TerapiaJuegoII")
    },
    {
      path: "/espiritualidad-religion-sanacion",
      name: "EspiritualidadSanacionReligion",
      component: () =>
        import("@/views/diplomados/EspiritualidadSanacionReligion")
    },
    {
      path: "/educacion-integral-de-la-sexualidad",
      name: "EduInteSexualidad",
      component: () => import("@/views/diplomados/EduInteSexualidad")
    },
    {
      path: "/comunicacion-no-verbal",
      name: "comuniocacionNoVerbal",
      component: () => import("@/views/diplomados/ComunicacionNoVerbal")
    },
    {
      path: "/administracion-y-finanzas",
      name: "AdmonFinanzas",
      component: () => import("@/views/diplomados/AdmonFinanzas")
    },
    {
      path: "/criminalistica",
      name: "Criminalistica",
      component: () => import("@/views/diplomados/Criminalistica")
    },
    {
      path: "/estrategias-litigacion-penal",
      name: "EstrategiasLitigacionPenal",
      component: () => import("@/views/diplomados/EstrategiasLitigacionPenal")
    },
    {
      path: "/tecnicas-neuro-ingenieria",
      name: "tecnicasNeuroIngenieria",
      component: () => import("@/views/diplomados/TecnicasNeuroIngenieria")
    },
    {
      path: "/metodos-alternos-solucion-conflictos",
      name: "metodosAlternosSolucionConflictos",
      component: () => import("@/views/diplomados/MetodosAlternosSolucionConflictos")
    },
    {
      path: "/derechos-humanos",
      name: "derechosHumanos",
      component: () => import("@/views/diplomados/DerechosHumanos")
    },
    {
      path: "/derechos-psicologos-mexicanos",
      name: "derechosPsicologosMexicanos",
      component: () => import("@/views/diplomados/DerechosPsicologosMexicanos")
    },
    {
      path: "/cuidados-paliativos",
      name: "cuidadosPaliativos",
      component: () => import("@/views/diplomados/CuidadosPaliativos")
    },
    {
      path: "/diplomado-suicidio",
      name: "diplomadoSuicidio",
      component: () => import("@/views/diplomados/Suicidio")
    },
    {
      path: "/urgencias-psicologicas",
      name: "urgenciasPsicologicas",
      component: () => import("@/views/diplomados/UrgenciasPsicologicas")
    },
    {
      path: "/psicotrauma",
      name: "psicotrauma",
      component: () => import("@/views/diplomados/Psicotrauma")
    },
    {
      path: "/capital-humano",
      name: "capitalHumano",
      component: () => import("@/views/diplomados/CapitalHumano")
    },
    {
      path: "/herramientas-psicologicas-gestion",
      name: "herramientasPsicologicasGestion",
      component: () => import("@/views/diplomados/HerramientasPsicologicasGestion")
    },
    {
      path: "/juicios-orales-civiles-familiares",
      name: "juiciosoralesCivilesFamiliares",
      component: () => import("@/views/diplomados/JuiciosOralesCivilesFamiliares")
    },
    {
      path: "/tecnicas-masajes-terapias",
      name: "tecnicasMasajesTerapias",
      component: () => import("@/views/diplomados/TecnicasMasajesTerapias")
    },
    {
      path: "/herramientas-metodologicas-trabajo-social",
      name: "herramientasMetodologicasTrabajoSociaal",
      component: () => import("@/views/diplomados/HerramientasMetodologicasTrabajoSocial")
    },
    {
      path: "/transformacion-digital-organizaciones",
      name: "transformacionDigitalOrganizaciones",
      component: () => import("@/views/diplomados/TransformacionDigitalOrganizaciones")
    },
    {
      path: "/trabajo-social-herramientas",
      name: "trabajoSocialHerramientas",
      component: () => import("@/views/diplomados/TrabajoSocialHerramientas")
    },
    {
      path: "/juicios-amparo",
      name: "juiciosAmparo",
      component: () => import("@/views/diplomados/JuiciosAmparo")
    },
    {
      path: "/ia-transformacion-digital",
      name: "iaTransformacionDigital",
      component: () => import("@/views/diplomados/IATransformacionDigital")
    },
    {
      path: "/psicologia-juridica",
      name: "psicologiaJuridica",
      component: () => import("@/views/diplomados/PsicologiaJuridica")
    },
    {
      path: "/gestion-empresarial-emprendimiento",
      name: "gestionEmpresarialEmprendimiento",
      component: () => import("@/views/diplomados/GestionEmpresarialEmprendimiento")
    },
    {
      path: "/escena-crimen-analisis-forense",
      name: "escenaCrimenAnalisisForense",
      component: () => import("@/views/diplomados/EscenaCrimenAnalisisForense")
    },
    {
      path: "/meditacion-enfoque-transpersonal",
      name: "meditacionEnfoqueTranspersonal",
      component: () => import("@/views/diplomados/MeditacionEnfoqueTranspersonal")
    },
    {
      path: "/desarrollo-organizacional-change-management",
      name: "desarrolloOrganizacionalChangeManagement",
      component: () => import("@/views/diplomados/DesarrolloOrganizacionalChangeManagement")
    },
    {
      path: "/transformacion-digital-ia",
      name: "transformacionDigitalIA",
      component: () => import("@/views/diplomados/TransformacionDigitalIA")
    },
    {
      path: "/acompannamiento-psicologico-crianza-ninnez",
      name: "acompannamientoPsicologicoCrianzaNinnez",
      component: () => import("@/views/diplomados/AcompannamientoPsicologicoCrianzaNinnez")
    },
    {
      path: "/derecho-corporativo",
      name: "derechoCorporativo",
      component: () => import("@/views/diplomados/DerechoCorporativo")
    },
    {
      path: "/terapia-familiar",
      name: "terapiaFamiliar",
      component: () => import("@/views/diplomados/TerapiaFamiliar")
    },
    {
      path: "/tecnicas-estrategias-neurociencia",
      name: "tecnicasEstrategiasNeurociencia",
      component: () => import("@/views/diplomados/TecnicasEstrategiasNeurociencia")
    },
    {
      path: "/desarrollo-organizacional-gestion-cambio",
      name: "desarrolloOrganizacionalGestionCambio",
      component: () => import("@/views/diplomados/DesarrolloOrganizacionalGestionCambio")
    },
    //FIN DIPLOMADOS
    //INICIO TALLERES
    {
      path: "/amor-a-mi-vejez",
      name: "amorvejez",
      component: () => import("@/views/talleres/AmorVejez")
    },
    {
      path: "/demandas-juridicas",
      name: "demandasjuridicas",
      component: () => import("@/views/talleres/DemandasJuridicas")
    },
    {
      path: "/aprendiendo-a-perdonar",
      name: "aprendiendoperdonar",
      component: () => import("@/views/talleres/AprendiendoPerdonar")
    },
    {
      path: "/autoestima",
      name: "autoestima",
      component: () => import("@/views/talleres/Autoestima")
    },
    {
      path: "/cerrando-ciclos",
      name: "ciclos",
      component: () => import("@/views/talleres/Ciclos")
    },
    {
      path: "/codependencia",
      name: "codependencia",
      component: () => import("@/views/talleres/Codependencia")
    },
    {
      path: "/cuidando-del-cuidador",
      name: "cuidador",
      component: () => import("@/views/talleres/Cuidador")
    },
    {
      path: "/despidiendo-mi-año",
      name: "despidiendo",
      component: () => import("@/views/talleres/Despidiendo")
    },
    {
      path: "/duelo",
      name: "duelo",
      component: () => import("@/views/talleres/Duelo")
    },
    {
      path: "/reencontrando-a-mi-niño-interior",
      name: "reencontrando",
      component: () => import("@/views/talleres/Reencontrando")
    },
    {
      path: "/risoterapia",
      name: "risoterapia",
      component: () => import("@/views/talleres/Risoterapia")
    },
    {
      path: "/viviendo-mi-propia-muerte",
      name: "viviendo",
      component: () => import("@/views/talleres/PropiaMuerte")
    },
    {
      path: "/yoga-de-la-risa",
      name: "yogarisa",
      component: () => import("@/views/talleres/YogaRisa")
    },
    {
      path: "/yoga-transpersonal",
      name: "yogatrans",
      component: () => import("@/views/talleres/YogaTrans")
    },
    {
      path: "/taller-diagnóstico-clínico-a-través-del-cine",
      name: "dcine",
      component: () => import("@/views/talleres/Dcine")
    },
    {
      path: "/mandalas-meditación-activa",
      name: "mandalas",
      component: () => import("@/views/talleres/Mandalas")
    },
    {
      path: "/atención-de-personas-que-viven-con-VIH",
      name: "atencion",
      component: () => import("@/views/talleres/AtencionPersonas")
    },
    {
      path: "/taller-expresión-en-público",
      name: "expublico",
      component: () => import("@/views/talleres/ExpresionPulico")
    },
    {
      path: "/violencia-covid",
      name: "violenciacovid",
      component: () => import("@/views/talleres/ViolenciaCovid")
    },
    {
      path: "/perdonar-contingencia",
      name: "perdonarcontingencia",
      component: () => import("@/views/talleres/PerdonarContingencia")
    },
    {
      path: "/psicogenealogia",
      name: "psicogenealogia",
      component: () => import("@/views/talleres/Psicogenealogia")
    },
    {
      path: "/duelo-covid",
      name: "duelocovid",
      component: () => import("@/views/talleres/DueloCovid")
    },
    {
      path: "/sanando-heridas-covid",
      name: "sanandoheridascovid",
      component: () => import("@/views/talleres/SanandoHeridasCovid")
    },
    {
      path: "/taller-sanacion-de-emociones",
      name: "preViolencias",
      component: () => import("@/views/talleres/SanacionEmociones")
    },
    {
      path: "/despertando-mis-recursos-internos-ante-el-covid-19",
      name: "rCovid",
      component: () => import("@/views/talleres/RecursosInternosCovid")
    },
    {
      path: "/cerrando-transpersonal",
      name: "cerrandoTranspersonal",
      component: () => import("@/views/talleres/CerrandoTranspersonal")
    },
    {
      path: "/cerrando-mi-año",
      name: "cerrandoAnualidad",
      component: () => import("@/views/talleres/CerrandoAnualidad")
    },
    {
      path: "/2021-Una-Nueva-Oportunidad",
      name: "NuevaOportunidad",
      component: () => import("@/views/talleres/NuevaOportunidad")
    },
    {
      path: "/Duelo-Integrar-Y-Dejar-Ir",
      name: "DueloIntegrarDejar",
      component: () => import("@/views/talleres/DueloIntegrarDejar")
    },
    {
      path: "/Afrontamiento-Ante-El-Estres-Escolar-Madres-Y-Padres",
      name: "AfrontamientoEstresEscolar",
      component: () => import("@/views/talleres/AfrontamientoEstresEscolar")
    },
    {
      path: "/tecnicas-para-afrontar-la-ansiedad-provocada-por-la-pandemia",
      name: "AnsiedadPandemia",
      component: () => import("@/views/talleres/AnsiedadPandemia")
    },
    {
      path: "/terapia-ocupacional-para-el-adulto-mayor-en-el-confinamiento",
      name: "TerapiaOcupacional",
      component: () => import("@/views/talleres/TerapiaOcupacional")
    },
    {
      path:
        "/la-risa-y-el-humor-como-recurso-de-afrontamiento-ante-la-pandemia",
      name: "HumorPandemia",
      component: () => import("@/views/talleres/HumorPandemia")
    },
    {
      path: "/motivacion-y-plenitud-en-el-entorno-escolar",
      name: "MotivacionEntornoEscolar",
      component: () => import("@/views/talleres/MotivacionEntornoEscolar")
    },
    {
      path: "/regreso-a-la-normalidad-en-las-escuelas",
      name: "regresoNormapandemia",
      component: () => import("@/views/talleres/RegresoAulasPandemia")
    },
    {
      path: "/duelo-ganancias-covid",
      name: "dueloGanancias",
      component: () => import("@/views/talleres/DueloGanancias")
    },
    {
      path: "/temor-contingencia-sanitaria",
      name: "termorSanitario",
      component: () => import("@/views/talleres/TemorSanitario")
    },
    {
      path: "/mitos-del-amor-romantico",
      name: "amorRomantico",
      component: () => import("@/views/talleres/AmorRomantico")
    },
    {
      path: "/descubriendo-mi-poder",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/DescubriendoPoder")
    },
    {
      path: "/autohomenaje-y-placer-femenino-como-forma-de-tracendencia",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/MasturbacionFemenina")
    },
    {
      path: "/homenaje-a-mi-pareja",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/MasturbarAalguien")
    },
    {
      path: "/aprendiento-a-perdonar-me",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/AprendiendoPerdonarMe")
    },
    {
      path: "/la-muerte-para-los-abogados-desde-la-mirada-humana-y-legal",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/LaMuerteAbogados")
    },
    {
      path: "/el-dolor-de-decir-adios",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/DolorAdios")
    },
    {
      path: "/aprendiendo-a-enveje-ser",
      name: "descubriendoPoder",
      component: () => import("@/views/talleres/AprendiendoEnvejeser")
    },
    {
      path: "/cerrando-heridas",
      name: "cerrandoHeridas",
      component: () => import("@/views/talleres/CerrandoHeridas")
    },
    {
      path: "/acoso-escolar",
      name: "acosoEscolar",
      component: () => import("@/views/talleres/AcosoEscolar")
    },
    {
      path: "/morfopsicologia-arrugas",
      name: "morfopsicologiaArrugas",
      component: () => import("@/views/talleres/MorfopsicologiaArrugas")
    },
    {
      path: "/aulas-creativas",
      name: "aulasCreativas",
      component: () => import("@/views/talleres/AulasCreativas")
    },
    {
      path: "/encuentro-ancestros",
      name: "encuentroAncestros",
      component: () => import("@/views/talleres/EncuentroAncestros")
    },
    {
      path: "/cuento-muerte",
      name: "cuentoMuerte",
      component: () => import("@/views/talleres/CuentoMuerte")
    },
    {
      path: "/aprendiendo-jugando",
      name: "aprendiendoJugando",
      component: () => import("@/views/talleres/AprendiendoJugando")
    },
    {
      path: "/despertando-ser-interior",
      name: "despertandoSerInterior",
      component: () => import("@/views/talleres/DespertandoSerInterior")
    },
    {
      path: "/titeres-recurso-didactico",
      name: "titeresRecursoDidactico",
      component: () => import("@/views/talleres/TiteresRecursoDidactico")
    },
    {
      path: "/repaso-neuroanatomia",
      name: "repasoNeuroanatomia",
      component: () => import("@/views/talleres/RepasoNeuroanatomia")
    },
    {
      path: "/poner-limites",
      name: "ponerLimites",
      component: () => import("@/views/talleres/PonerLimites")
    },
    {
      path: "/activa-potencial",
      name: "activaPotencial",
      component: () => import("@/views/talleres/ActivaPotencial")
    },
    {
      path: "/elaboracion-informe-psicopedagogico",
      name: "elaboracionInformePsicopedagogico",
      component: () => import("@/views/talleres/ElaboracionInformePsicopedagogico")
    },
    {
      path: "/aplicaciones-inversion",
      name: "aplicacionesInversion",
      component: () => import("@/views/talleres/AplicacionesInversion")
    },
    {
      path: "/tinker-cad",
      name: "tinkerCAD",
      component: () => import("@/views/talleres/TinkerCAD")
    },
    {
      path: "/simulador-mercados",
      name: "simuladorMercados",
      component: () => import("@/views/talleres/SimuladorMercados")
    },
    {
      path: "/violencia-escolar",
      name: "violenciaEscolar",
      component: () => import("@/views/talleres/ViolenciaEscolar")
    },
    {
      path: "/aprendiendo-amarme",
      name: "aprendiendoAmarme",
      component: () => import("@/views/talleres/AprendiendoAmarme")
    },
    {
      path: "/intervencion-dificultades-aprendizaje",
      name: "intervencionDificultadesAprendizaje",
      component: () => import("@/views/talleres/IntervencionDificultadesAprendizaje")
    },
    {
      path: "/aprendiendo-comunicarme",
      name: "aprendiendoComunicarme",
      component: () => import("@/views/talleres/AprendiendoComunicarme")
    },
    {
      path: "/tecnicas-ludicas-adulto",
      name: "tecnicasLudicasAdulto",
      component: () => import("@/views/talleres/TecnicasLudicasAdulto")
    },
    {
      path: "/importancia-ed-sexual-infancias",
      name: "importanciaEdSexualInfancias",
      component: () => import("@/views/talleres/ImportanciaEdSexualInfancias")
    },
    {
      path: "/importancia-juego-infancias",
      name: "importanciaJuegoInfancias",
      component: () => import("@/views/talleres/ImportanciaJuegoInfancias")
    },{
      path: "/metas-proposito",
      name: "metasProposito",
      component: () => import("@/views/talleres/MetasProposito")
    },{
      path: "/heridas-nacimiento",
      name: "heridasNacimiento",
      component: () => import("@/views/talleres/HeridasNacimiento")
    },{
      path: "/sexualidad-placentera-etapa-adulta",
      name: "sexualidadPlacenteraEtapaAdulta",
      component: () => import("@/views/talleres/SexualidadPlacenteraEtapaAdulta")
    },{
      path: "/estimulacion-lenguaje-03",
      name: "estimulacionLenguaje03",
      component: () => import("@/views/talleres/EstimulacionLenguaje03")
    },
    {
      path: "/inteligencia-emocional",
      name: "inteligenciaEmocional",
      component: () => import("@/views/talleres/InteligenciaEmocional")
    },
    {
      path: "/tecnicas-intervencion-tanatologicas",
      name: "tecnicasIntervencionTanatologicas",
      component: () => import("@/views/talleres/TecnicasIntervencionTanatologicas")
    },
    {
      path: "/disenna-metas-2026",
      name: "disennaMetas2026",
      component: () => import("@/views/talleres/DisennaMetas2026")
    },
    {
      path: "/vision-accion",
      name: "visionAccion",
      component: () => import("@/views/talleres/VisionAccion")
    },
    {
      path: "/autoconocimiento",
      name: "autoconocimiento",
      component: () => import("@/views/talleres/Autoconocimiento")
    },
    {
      path: "/elaboracion-demandas",
      name: "elaboracionDemandas",
      component: () => import("@/views/talleres/ElaboracionDemandas")
    },
    {
      path: "/plenaria-posesion",
      name: "plenariaPosesion",
      component: () => import("@/views/talleres/PlenariaPosesion")
    },
    {
      path: "/amor-codependencia",
      name: "amorCodependencia",
      component: () => import("@/views/talleres/AmorCodependencia")
    },
    {
      path: "/explorando-sexualidad",
      name: "explorandoSexualidad",
      component: () => import("@/views/talleres/ExplorandoSexualidad")
    },
    {
      path: "/inmersion-sonora",
      name: "inmersionSonora",
      component: () => import("@/views/talleres/InmersionSonora")
    },
    {
      path: "/cuento-recurso-socioemocional",
      name: "cuentoRecursoSocioemocional",
      component: () => import("@/views/talleres/CuentoRecursoSocioemocional")
    },
    {
      path: "/nuevo-proceso-civil-familiar",
      name: "nuevoProcesoCivilFamiliar",
      component: () => import("@/views/talleres/NuevoProcesoCivilFamiliar")
    },
    {
      path: "/transformar-dolor-significado",
      name: "transformarDolorSignificado",
      component: () => import("@/views/talleres/TransformarDolorSignificado")
    },
    {
      path: "/construyendo-anno-proposito",
      name: "construyendoAnnoProposito",
      component: () => import("@/views/talleres/ConstruyendoAnnoProposito")
    },
    {
      path: "/renacer-despues-adversidad",
      name: "renacerDespuesAdversidad",
      component: () => import("@/views/talleres/RenacerDespuesAdversidad")
    },
    {
      path: "/iniciando-anno-significado",
      name: "iniciandoAnnoSignificado",
      component: () => import("@/views/talleres/IniciandoAnnoSignificado")
    },
    {
      path: "/del-derecho-administracion",
      name: "delDerechoAdministracion",
      component: () => import("@/views/talleres/DelDerechoAdministracion")
    },
    {
      path: "/entre-salud-ley",
      name: "entreSaludLey",
      component: () => import("@/views/talleres/EntreSaludLey")
    },
    {
      path: "/neurodiversidad-inclusion",
      name: "neurodiversidadInclusion",
      component: () => import("@/views/talleres/NeurodiversidadInclusion")
    },
    {
      path: "/morir-derecho",
      name: "morirDerecho",
      component: () => import("@/views/talleres/MorirDerecho")
    },
    //FIN TALLERES
    //INICIO CURSOS
    {
      path: "/aromaterapia",
      name: "aromaterapia",
      component: () => import("@/views/cursos/Aromaterapia")
    },
    {
      path: "/examinación-del-estado-mental",
      name: "examinacion",
      component: () => import("@/views/cursos/Examinacion")
    },
    {
      path: "/amores-placeres-trascendencia",
      name: "amoresplacerestrascendencia",
      component: () => import("@/views/cursos/AmoresPlaceresTrascendencia")
    },
    {
      path: "/expresión-en-público",
      name: "expresion",
      component: () => import("@/views/cursos/Expresion")
    },
    {
      path: "/las-religiones-su-estudio-y-su-apoyo-terapéutico",
      name: "religiones",
      component: () => import("@/views/cursos/Religiones")
    },
    {
      path: "/lectura-comprensión-y-redacción-de-textos",
      name: "lectura",
      component: () => import("@/views/cursos/LecturaComprension")
    },
    {
      path: "/psicofarmacologia-para-psicologos",
      name: "psicofarmalogia",
      component: () => import("@/views/cursos/FarmacologiaPsicologos")
    },
    {
      path: "/el-proceso-penal-y-la-teoría-del-delito",
      name: "proceso",
      component: () => import("@/views/cursos/ProcesoPenal")
    },
    {
      path: "/construyendo-el-debate",
      name: "debate",
      component: () => import("@/views/cursos/ConstruyendoDebate")
    },
    {
      path: "/desarrollo-humano-covid",
      name: "desarrollohumanocovid",
      component: () => import("@/views/cursos/DesarrolloHumCovid")
    },
    {
      path: "/curso-juicios-orales",
      name: "cursojuiciosorales",
      component: () => import("@/views/cursos/CursoJuiciosOrales")
    },
    {
      path: "/herramientas-material-didactico",
      name: "herramientasmaterialdidactico",
      component: () => import("@/views/cursos/HerramientasMaterialDidactico")
    },
    {
      path: "/herramientas-teo-meto-sociales",
      name: "herramientasteometosociales",
      component: () => import("@/views/cursos/HerramientasTeoMetoSociales")
    },
    {
      path: "/escenarios-aprendizaje-virtuales",
      name: "escenariosaprendizajevirtuales",
      component: () => import("@/views/cursos/EscenariosAprendizajeVirtuales")
    },
    {
      path: "/curso-terapia-de-pareja-y-sexualidad",
      name: "Teraparejacurso",
      component: () => import("@/views/cursos/TerapiaParejaSexualidad")
    },
    {
      path: "/aprendizaje-autogestivo",
      name: "aprendizajeautogestivo",
      component: () => import("@/views/cursos/AprendizajeAutogestivo")
    },
    {
      path: "/innovacion-de-las-rutinas-docentes",
      name: "rutinaDocentes",
      component: () => import("@/views/cursos/RutinasDocentes")
    },
    {
      path: "/aprendizaje-estrategico-y-tecnicas-de-estudio",
      name: "tecnicasEstudio",
      component: () => import("@/views/cursos/TecnicasEstudio")
    },
    {
      path:
        "/el-derecho-constitucional-como-principio-rector-de-las-reformas-del-estado-mexicano",
      name: "derechoConstitucional",
      component: () => import("@/views/cursos/DerechoConstitucional")
    },
    {
      path: "/adicciones-en-el-individuo-y-la-familia",
      name: "cursoAdicciones",
      component: () => import("@/views/cursos/CursoAdicciones")
    },
    {
      path: "/curso-psicogenealogia",
      name: "cursoPsicogenealogia",
      component: () => import("@/views/cursos/CursoPsicogenealogia")
    },
    {
      path: "/el-poder-femenino-y-los-derechos",
      name: "PoderFemenino",
      component: () => import("@/views/cursos/PoderFemenino")
    },
    {
      path: "/trabajo-social-de-casos",
      name: "TrabajoSocialCasos",
      component: () => import("@/views/cursos/TrabajoSocialCasos")
    },
    {
      path: "/curso-relaciones-humanas-y-trabajo-en-equipo",
      name: "rhytee",
      component: () => import("@/views/cursos/RhYtrabajoEquipo")
    },
    {
      path: "/curso-orientacion-vocacional",
      name: "OrientacionVocacional",
      component: () => import("@/views/cursos/OrientacionVocacional")
    },
    {
      path: "/reporte-de-casos-clinicos",
      name: "reporteCasosClinicos",
      component: () => import("@/views/cursos/ReporteCasosClinicos")
    },
    {
      path: "/invitacion-al-pensamiento-critico",
      name: "pensamientoCritico",
      component: () => import("@/views/cursos/InvitacionPensamiento")
    },
    {
      path: "/curso-práctico-lengua-de-señas-mexicanas",
      name: "lenguajesenas",
      component: () => import("@/views/cursos/LenguajeSenas")
    },
    {
      path: "/herramientas-para-la-inclusión-social",
      name: "pensamientoCritico",
      component: () => import("@/views/cursos/HerramientasInclusion")
    },
    {
      path: "/desarrollo-de-habilidades-emocionales",
      name: "pensamientoCritico",
      component: () => import("@/views/cursos/DesarrolloEmo")
    },
    {
      path: "/actualizacion-metodologica-en-trabajo-social",
      name: "actualizacionMetodologica",
      component: () => import("@/views/cursos/ActualizacionMetodologica")
    },
    {
      path: "/elaboracion-de-instrumentos-en-el-trabajo-social",
      name: "elaboraInstrumentos",
      component: () => import("@/views/cursos/ElaboraInstrumentos")
    },
    {
      path: "/leyendo-a-michel-foucalt",
      name: "leyendoMichel",
      component: () => import("@/views/cursos/LeyendoMichel")
    },
    {
      path: "/glandula-pineal",
      name: "glandulaPineal",
      component: () => import("@/views/cursos/GlandulaPineal")
    },
    {
      path: "/formacion-cuidadores-domicilio",
      name: "formacionCuidadoresDomicilio",
      component: () => import("@/views/cursos/FormacionCuidadoresDomicilio")
    },
    {
      path: "/sociologia-suicidio",
      name: "sociologiaSuicidio",
      component: () => import("@/views/cursos/SociologiaSuicidio")
    },
    {
      path: "/habilidades-intervencion-psicooncologica",
      name: "habilidadesIntervencionPsicooncologica",
      component: () => import("@/views/cursos/HabilidadesIntervencionPsicooncologica")
    },
    {
      path: "/terapia-gerontologica",
      name: "terapiaGerontologica",
      component: () => import("@/views/cursos/TerapiaGerontologica")
    },
    {
      path: "/cursoTEA",
      name: "cursoTEA",
      component: () => import("@/views/cursos/TEA")
    },
    {
      path: "/cursoAuxiliarEnfermeria",
      name: "cursoAuxiliarEnfermeria",
      component: () => import("@/views/cursos/CursoAuxiliarEnfermeria")
    },
    {
      path: "/sanandoArbol",
      name: "sanandoArbol",
      component: () => import("@/views/cursos/SanandoArbol")
    },
    {
      path: "/propioAgenteSalud",
      name: "propioAgenteSalud",
      component: () => import("@/views/cursos/PropioAgenteSalud")
    },
    {
      path: "/toma-muestras-biologicas",
      name: "tomaMuestrasBiologicas",
      component: () => import("@/views/cursos/TomaMuestrasBiologicas")
    },
    /*{
      path: "/autoestima",
      name: "autoestima",
      component: () => import("@/views/cursos/Autoestima")
    },*/
    {
      path: "/sociedad-matematica",
      name: "sociedadMatematica",
      component: () => import("@/views/cursos/SociedadMatematica")
    },
    {
      path: "/psicologia-rostro-cuerpo",
      name: "psicologiaRostroCuerpo",
      component: () => import("@/views/cursos/PsicologiaRostroCuerpo")
    },
    {
      path: "/neurodesarrollo",
      name: "neurodesarrollo",
      component: () => import("@/views/cursos/Neurodesarrollo")
    },
    {
      path: "/tablas-matematicas",
      name: "tablasMatematicas",
      component: () => import("@/views/cursos/TablasMatematicas")
    },
    {
      path: "/cursos-adicciones",
      name: "cursosAdicciones",
      component: () => import("@/views/cursos/Adicciones")
    },
    {
      path: "/principios-grafologia",
      name: "principiosGrafologia",
      component: () => import("@/views/cursos/PrincipiosGrafologia")
    },
    {
      path: "/eneagrama-transpersonal",
      name: "eneagramaTranspersonal",
      component: () => import("@/views/cursos/EneagramaTranspersonal")
    },
    {
      path: "/tablas-excel-basico",
      name: "tablasExcelBasico",
      component: () => import("@/views/cursos/TablasExcelBasico")
    },
    {
      path: "/bioenergetica-terapia-movimiento",
      name: "bioenergeticaTerapiaMovimiento",
      component: () => import("@/views/cursos/BioenergeticaTerapiaMovimiento")
    },
    {
      path: "/intervencion-psicooncologica",
      name: "intervencionPsicooncologica",
      component: () => import("@/views/cursos/IntervencionPsicooncologica")
    },
    {
      path: "/suenno-transtornos",
      name: "suennoTranstornos",
      component: () => import("@/views/cursos/SuennoTranstornos")
    },
    {
      path: "/primeros-auxilios-basicos",
      name: "primerosAuxiliosBasicos",
      component: () => import("@/views/cursos/PrimerosAuxiliosBasicos")
    },
    {
      path: "/tablas-excel-medio",
      name: "tablasExcelMedio",
      component: () => import("@/views/cursos/TablasExcelMedio")
    },
    {
      path: "/disena-impacta-chatgpt-canva",
      name: "disenaImpactaChatGPTCanva",
      component: () => import("@/views/cursos/DisenaImpactaChatGPTCanva")
    },
    {
      path: "/resolviendo-duelos",
      name: "resolviendoDuelos",
      component: () => import("@/views/cursos/ResolviendoDuelos")
    },
    {
      path: "/conexion-cuantico-psicoterapia",
      name: "suennoTranstornos",
      component: () => import("@/views/cursos/ConexionCuanticoPsicoterapia")
    },
    {
      path: "/sanando-heridas-transgeneracionales",
      name: "sanandoHeridasTransgeneracionales",
      component: () => import("@/views/cursos/SanandoHeridasTransgeneracionales")
    },
    {
      path: "/curso-intervencion-tanatologica",
      name: "cursoIntervencionTanatologica",
      component: () => import("@/views/cursos/CursoIntervencionTanatologica")
    },
    {
      path: "/inteligencia-emocional-aplicada",
      name: "inteligenciaEmocionalAplicada",
      component: () => import("@/views/cursos/InteligenciaEmocionalAplicada")
    },
    {
      path: "/intervencion-psicosocial-integrativa",
      name: "intervencionPsicosocialIntegrativa",
      component: () => import("@/views/cursos/IntervencionPsicosocialIntegrativa")
    },
    //FIN CURSOS
    //INICIO PREPARATORIO
    {
      path: "/preparatorio-de-investigacion",
      name: "preparatorio",
      component: () => import("@/views/seminarios/Preparatorio")
    },
    /*{
      path: "/sociología-del-suicidio",
      name: "suicidio",
      component: () => import("@/views/seminarios/Suicidio")
    },*/
    {
      path: "/historia-academica",
      name: "historia",
      component: () => import("@/views/nosotros/Historia")
    },
    {
      path: "/nuestros-objetivos",
      name: "objetivos",
      component: () => import("@/views/nosotros/Objetivos")
    },
    {
      path: "/nuestra-filosofía",
      name: "filosofia",
      component: () => import("@/views/nosotros/Filosofia")
    },
    {
      path: "/clínica-psicoterapéutica",
      name: "clinica",
      component: () => import("@/views/Clinica")
    },
    {
      path: "/parkinson",
      name: "parkinson",
      component: () => import("@/views/Parkinson")
    },
    {
      path: "/programa-radio",
      name: "programaRadio",
      component: () => import("@/views/ProgramaRadio")
    },
    {
      path: "/eventos-del-mes",
      name: "eventosMes",
      component: () => import("@/views/Eventos")
    },
    {
      path: "/becas",
      name: "becas",
      component: () => import("@/views/Becas")
    },
    {
      path: "/contactanos",
      name: "contactanos",
      component: () => import("@/views/Contacto")
    },
    //EVENTOS
    {
      path: "/congreso-de-psicoterapia-transpersonal",
      name: "psicoteratrans",
      component: () => import("@/views/eventos/PsicoteraTrans")
    },
    {
      path: "/congreso-tanatologia",
      name: "congresoTanatologia",
      component: () => import("@/views/eventos/CongresoTanatologia")
    },
    {
      path: "/congreso-internacional-de-educación",
      name: "congresoEducacion",
      component: () => import("@/views/eventos/CongresoEducacion")
    },
    {
      path: "/congreso-estudio-del-suicidio",
      name: "congresoEstudiosuicidio",
      component: () => import("@/views/eventos/EstudioSuicidio")
    },
    {
      path: "/congreso-psicologia",
      name: "congresoPsicologia",
      component: () => import("@/views/eventos/CongresoPsicologia")
    },
    {
      path: "/encuentro-psicooncologia",
      name: "encuentroPsicooncologia",
      component: () => import("@/views/eventos/EncuentroPsicooncologia")
    },
    //GALERÍA
    {
      path: "/galeria",
      name: "galeria",
      component: () => import("@/views/Galeria")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js